import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider, FieldArray, getIn } from 'formik';
import { connect } from "react-redux";
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { DropzoneArea } from "material-ui-dropzone";
// material
import {
    Link,
    Card,
    Stack,
    Checkbox,
    TextField,
    IconButton,
    InputAdornment,
    FormControlLabel,
    Container,
    Typography,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    Grid,
    Button,
    TextareaAutosize
} from '@mui/material';
import { ListHead, ListToolbar, MoreMenu } from '../../components/_dashboard/car';
import { LoadingButton } from '@mui/lab';
import Scrollbar from '../../components/Scrollbar';
import { createAgreement } from '../../actions/agreementAction';
import _ from 'lodash';
import Page from '../../components/Page';
import { styled } from '@mui/material/styles';
import Edit from "@material-ui/icons/Edit";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import ModalCompoennt from '../Portal/ModalCompoennt';


// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 680,
    margin: 'auto',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
}));

const TABLE_HEAD = [
    { id: 'id', label: 'ID', alignRight: false },
    { id: 'name', label: 'Name', alignRight: false },
    { id: 'email', label: 'Email', alignRight: false },
    { id: 'action', label: 'Actions', alignRight: false },
];


function CreateAgreement(props) {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [adminObj, setAdminObj] = useState({});
    const [openUpdate, setOpenUpdate] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [files, setFiles] = useState([]);
    
    const AddSchema = Yup.object().shape({
        description: Yup.string().required('Description is required'),
        witness_name: Yup.string().required('Witness name is required'),
        witness_telephone: Yup.string().required('Witness telephone no is required'),
        notes: Yup.array().of(
            Yup.object().shape({
                note : Yup.string().required("Note is required"),
            })
        )
    });

    const formik = useFormik({
        initialValues: {
            car_detail_id:'',
            description:'',
            witness_name:'',
            witness_telephone:'',
            notes: [
                {
                    id: Math.random(),
                    note: "PENALTY OF 30% WILL BE CHARGED FROM THE CLIENT UPON FAILURE TO PAY THE ABOVE-MENTIONED BALANCE",
                }
            ]
        },
    validationSchema: AddSchema,
        onSubmit: (values, {resetForm}) => {
            resetForm();
            setIsLoading(true);
            const fd = new FormData();
            fd.append('description',values.description);
            fd.append('witness_name',values.witness_name);
            fd.append('witness_telephone',values.witness_telephone);
            fd.append('car_detail_id',props.carObj.carObj.id);
            fd.append('notes', JSON.stringify(values.notes));
            files.forEach(file => {
                fd.append('files[]', file, file.name);
            });
            props.createAgreement(fd);
        }
    });

    const handleFileChange = (files) => {
        setFiles(files);
    }

    useEffect(() => {
        setIsLoading(false);
        if(props.alerts.status == 'success') {
            props.onDismis();
            navigate('/dashboard/agreements', { replace: true });
        }
    }, [props.alerts]);

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, handleChange, handleBlur } = formik;

    return (
        <Page title="CreateAgreement">
            <Container maxWidth="lg">
                <Card sx={{padding:"1em"}}>
                    <Stack sx={{ mb: 5 }}>
                        <Typography variant="h5" gutterBottom>
                            Agreement
                        </Typography>
                        <Typography sx={{ color: 'text.secondary' }} gutterBottom>Car Details</Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <b>Car Name:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.motor}
                            </Grid>
                            <Grid item xs={6}>
                                <b>Chasis No:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.chasis_no}
                            </Grid>
                            <Grid item xs={6}>
                                <b>Engine No:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.engine_no}
                            </Grid>
                            <Grid item xs={6}>
                                <b>Registration No:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.reg_no}
                            </Grid>
                        </Grid>
                    </Stack>
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <FieldArray name="notes">
                                {({ push, pop }) => (
                                    <div>
                                        <div style={{float:"right"}}>
                                            <Button style={{padding:"0px 4px 0px 4px", cursor:"pointer"}} variant="danger" onClick={() => {
                                                    if(values.notes.length > 1) {
                                                        pop('notes')
                                                    }
                                                }}
                                            >
                                                -
                                            </Button>
                                            <Button style={{padding:"0px 2px 0px 2px", cursor:"pointer", marginRight:"3px"}} variant="primary" onClick={() => {
                                                    push({ id: Math.random(), note: "" })
                                                }}
                                            >
                                                +
                                            </Button> 
                                        </div>
                                        {values.notes.map((p, index) => {
                                            const note = `notes[${index}].note`;
                                            const touchedNote = getIn(touched, note);
                                            const errorNote = getIn(errors, note);
                                            return (
                                                <div id={p.id}>
                                                    <TextField
                                                        fullWidth
                                                        margin="normal"
                                                        variant="outlined"
                                                        label="Note on agreement"
                                                        name={note}
                                                        value={p.note}
                                                        required
                                                        helperText={
                                                            touchedNote && errorNote
                                                            ? errorNote
                                                            : ""
                                                        }
                                                        error={Boolean(touchedNote && errorNote)}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </FieldArray>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography gutterBottom>
                                        <b>Upload Attachment</b>
                                    </Typography>
                                    {/* <TextField
                                        fullWidth
                                        type="file"
                                        name="logo"
                                        onChange={onChangeHandler}
                                    /> */}
                                    <DropzoneArea filesLimit={10} onChange={handleFileChange} acceptedFiles={["image/*"]} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography gutterBottom>
                                        <b>Description</b>
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        type="text"
                                        label="Description*"
                                        {...getFieldProps('description')}
                                        error={Boolean(touched.description && errors.description)}
                                        helperText={touched.description && errors.description}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography gutterBottom>
                                        <b>Witness Name</b>
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        type="text"
                                        label="Witness Name*"
                                        {...getFieldProps('witness_name')}
                                        error={Boolean(touched.witness_name && errors.witness_name)}
                                        helperText={touched.witness_name && errors.witness_name}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography gutterBottom>
                                        <b>Witness Telephone</b>
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        label="Witness Telephone*"
                                        {...getFieldProps('witness_telephone')}
                                        error={Boolean(touched.witness_telephone && errors.witness_telephone)}
                                        helperText={touched.witness_telephone && errors.witness_telephone}
                                    />
                                </Grid>
                            </Grid>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
                            </Stack>
                            <LoadingButton
                                size="large"
                                type="submit"
                                variant="contained"
                                loading={isLoading}
                                sx={{backgroundColor: '#c29136',float:"right"}}
                            >
                                create
                            </LoadingButton>
                        </Form>
                    </FormikProvider>
                </Card>
            </Container>
        </Page>
    );
}
const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        alerts: state.alerts,
    }
}

export default connect(mapStateToProps, { createAgreement })(CreateAgreement);

